import DonationDto from '@/src/models/DonationDto';
import dayjs from 'dayjs';

export interface DonationWebviewTemplate
  extends Partial<
    Omit<Omit<DonationDto, 'participantsCnt'>, 'participantsCredit'>
  > {
  ddayText: string;
  thumbnailImageBufferFullUrl: string;
  sponsorImageBufferFullUrl: string;
  infosList: string;
  cautionsList: string;
  ddayTextDisplayYn: boolean;
  thumbnailImageBufferFullUrlDisplayYn: boolean;
  subTitleDisplayYn: boolean;
  sponsorDividerDisplayYn: boolean;
  sponsorImageBufferFullUrlDisplayYn: boolean;
  sponsorDescriptionDisplayYn: boolean;
  sponsorPageLinkDisplayYn: boolean;
  infosDisplayYn: boolean;
  cautionsDisplayYn: boolean;
  infosDividerDisplayYn: boolean;
  infoAndCautionDisplayYn: boolean;
  isEndedDisplayYn: boolean;
  participantsCnt: string;
  participantsCredit: string;
  minimumCreditText: string;
}

export const donationWebviewMapper = (
  data?: Partial<DonationDto>,
): DonationWebviewTemplate => {
  const dday = dayjs(data?.endedAt)
    .startOf('D')
    .diff(dayjs().startOf('D'), 'days');

  return {
    ...data,
    title: data?.title || '제목을 입력해주세요.',
    contents: data?.contents || '내용을 입력해주세요.',
    endedAt: dayjs(data?.endedAt).format('YYYY.MM.DD HH:mm'),
    participantsCnt:
      typeof data?.participantsCnt === 'number'
        ? data?.participantsCnt.toLocaleString()
        : '1,000',
    ddayText: dday > 0 ? `${dday}일 남음` : '오늘 마감',
    thumbnailImageBufferFullUrl: data?.thumbnailImage?.bufferFullUrl || '',
    sponsorImageBufferFullUrl: data?.sponsorImage?.bufferFullUrl || '',
    infosList: data?.donationInfos
      ? data?.donationInfos?.map(item => `<li>${item.contents}</li>`).join('')
      : '',
    cautionsList: data?.donationCautions
      ? data?.donationCautions
          ?.map(item => `<li>${item.contents}</li>`)
          .join('')
      : '',
    minimumCreditText: `${(data?.minimumCredit || 10).toLocaleString()}크레딧`,
    participantsCredit: `${typeof data?.participantsCredit === 'number' ? data?.participantsCredit.toLocaleString() : '1,000,000'}C`,
    // displayYn
    ddayTextDisplayYn: !(dday < 0),
    thumbnailImageBufferFullUrlDisplayYn: !!data?.thumbnailImage?.bufferFullUrl,
    subTitleDisplayYn: !!data?.subTitle,
    sponsorDividerDisplayYn:
      !!data?.sponsorImage?.bufferFullUrl ||
      !!data?.sponsorDescription ||
      !!data?.sponsorLink,
    sponsorImageBufferFullUrlDisplayYn: !!data?.sponsorImage?.bufferFullUrl,
    sponsorDescriptionDisplayYn: !!data?.sponsorDescription,
    sponsorPageLinkDisplayYn: !!data?.sponsorLink,
    infosDisplayYn: (data?.donationInfos?.length || 0) > 0,
    cautionsDisplayYn: (data?.donationCautions?.length || 0) > 0,
    infosDividerDisplayYn:
      (data?.donationInfos?.length || 0) > 0 &&
      (data?.donationCautions?.length || 0) > 0,
    infoAndCautionDisplayYn:
      (data?.donationInfos?.length || 0) > 0 ||
      (data?.donationCautions?.length || 0) > 0,
    bottomButtonDisplayYn:
      !!data?.bottomButtonDisplayYn &&
      !!data?.bottomButtonName &&
      !!data?.bottomButtonLink,
    isEndedDisplayYn: dayjs(data?.endedAt).isBefore(dayjs(), 'days'),
  };
};
